import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Helpers } from "../../helpers";
import { AppSidebar } from '../app-sidebar/app-sidebar.component';
import { CompanyService } from '../../services/Company/company.service';

import * as $ from "jquery";
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements AfterViewInit {

  @ViewChild(AppSidebar, { static: true }) child;
  complist: any;

  constructor(private router: Router, private companyService: CompanyService) {
    this.complist = this.companyService.getList();
    //console.log("RUN!!!!!!! " + this.complist);
  }

  ngOnInit() {
    $(".pop-up-bg").on('click', function() {
      $(".pop-up-bg").toggle();

      if ($(".pop-up-bg").is(':visible')) {
        $("body").css("overflow-y", "hidden");
      }
      else {
        $("body").css("overflow-y", "scroll");
      }
    });

    /*$(".comp-list").slimScroll({
      color: '#FAFAFA',
      size: '5px',
      height: '450px'
    });*/

    $('.to-top').click(function(e) {
      $("html, body").animate({ scrollTop: 0 }, 500);
      console.log("click");
    });

    /*$("#side-popup").slimScroll({
      height: '70%',
			railOpacity: '0.9',
    })*/
  }

  ngAfterViewInit() {

    Helpers.initLayout();

  }

  update() {
    alert("update")
  }

  goComp(id) {
    this.router.navigate(['./company/' + id]);
  }

  receiveMessage($event) {
    //console.log("CCCC11111>>>" + JSON.stringify($event));
    //alert("I am runing " + JSON.stringify($event));
    this.complist = $event
  }
}
